// extracted by mini-css-extract-plugin
export default {"App":"Header_App__69PJ0","appLogo":"Header_appLogo__QAllS","App-logo-spin":"Header_App-logo-spin__p2xvY","appHeader":"Header_appHeader__l+FQG","appLink":"Header_appLink__Uj5Wh"};